import React from 'react'
import Breadcrumb from '../components/Breadcrumb'
import CoreServices from '../components/Services/CoreServices'
import ServicesSidebar from '../components/ServicesSidebar'
import Tags from '../components/Tags'

function Services() {
    return (
        <>
            <Breadcrumb title={"Services"} tag ="Services"/>
            {/* <!--services details start--> */}
            <section className="service-details-section pt-100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-md-8">
                            <CoreServices />
                        </div>
                        <ServicesSidebar />
                    </div>
                    <Tags />
                </div>
            </section>
            {/* <!--services details end--> */}

        </>
    )
}

export default Services
